import React from 'react';
import PropTypes from 'prop-types';

import {
    Table
} from "react-bootstrap";

import Button from 'components/CustomButton/CustomButton.jsx';

class ProductListFields extends React.Component {

    render() {
        return (
            <div>
                <Table>
                    <tbody>
                    <tr>
                        <td>
                            <Button
                                simple
                                bsStyle="info"
                                onClick={() => this.props.setField('contreIndicationsListe')}
                                fill={this.props.field === 'contreIndicationsListe'}
                            >
                                Contre indications liste
                            </Button>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <Button
                                simple
                                bsStyle="info"
                                onClick={() => this.props.setField('indicationsListe')}
                                fill={this.props.field === 'indicationsListe'}
                            >
                                Indications liste
                            </Button>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <Button
                                simple
                                bsStyle="info"
                                onClick={() => this.props.setField('interactionsContreIndiquees')}
                                fill={this.props.field === 'interactionsContreIndiquees'}
                            >
                                Interactions contre indiquées
                            </Button>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <Button
                                simple
                                bsStyle="info"
                                onClick={() => this.props.setField('interactionsDeconseillees')}
                                fill={this.props.field === 'interactionsDeconseillees'}
                            >
                                Interactions déconseillées
                            </Button>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <Button
                                simple
                                bsStyle="info"
                                onClick={() => this.props.setField('interactionsDepourvue')}
                                fill={this.props.field === 'interactionsDepourvue'}
                            >
                                Interactions dépourvues {"d'interactions"}
                            </Button>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <Button
                                simple
                                bsStyle="info"
                                onClick={() => this.props.setField('interactionsPrecaution')}
                                fill={this.props.field === 'interactionsPrecaution'}
                            >
                                Interactions à prendre avec précaution
                            </Button>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <Button
                                simple
                                bsStyle="info"
                                onClick={() => this.props.setField('interactionsPrendreCompte')}
                                fill={this.props.field === 'interactionsPrendreCompte'}
                            >
                                Interactions à prendre en compte
                            </Button>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <Button
                                simple
                                bsStyle="info"
                                onClick={() => this.props.setField('interactionsSynergique')}
                                fill={this.props.field === 'interactionsSynergique'}
                            >
                                Interactions synergiques
                            </Button>
                        </td>
                    </tr>
                    </tbody>
                </Table>
            </div>
        );
    }
}

ProductListFields.propTypes = {

    field: PropTypes.string,
    setField: PropTypes.func,

};

export default ProductListFields;